import { render, staticRenderFns } from "./part.vue?vue&type=template&id=770a3e80&"
import script from "./part.vue?vue&type=script&lang=js&"
export * from "./part.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports